module.exports = __webpack_public_path__ + "08_mustache_black.41d5edc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/08_mustache_black.png
// module id = 9ra0
// module chunks = 0